import React from 'react';
import PropTypes from 'prop-types';
import { Card } from '@opendate-app/setlist';
import { formatCompactMoney } from '../../shared/utils/crmMoney';
import crmLabels from '../../shared/utils/crmLabels';

const DELTA_COLOR = {
  up: 'var(--sl-text-success, #067647)',
  warn: 'var(--sl-text-error, #B42318)',
};

function KpiRow({ kpis, loading, teamId, labels = crmLabels(undefined), showDeals = true }) {
  const k = kpis || {};
  const contacts = k.contacts || {};
  const orgs = k.organizations || {};
  const deals = k.open_deals || {};
  const tasks = k.tasks || {};
  const base = `/teams/${teamId}/crm`;

  const cards = [
    {
      label: labels.contact.plural,
      href: `${base}/fans`,
      value: (contacts.total || 0).toLocaleString(),
      delta: contacts.total ? { text: `+${(contacts.this_week || 0).toLocaleString()} this week`, tone: 'up' }
                            : { text: 'Import or add your first contacts', tone: 'muted' },
    },
    {
      label: labels.organization.plural,
      href: `${base}/organizations`,
      value: (orgs.total || 0).toLocaleString(),
      delta: orgs.total ? { text: `+${orgs.this_week || 0} this week`, tone: 'muted' }
                        : { text: `Created automatically from ${labels.contact.plural.toLowerCase()}`, tone: 'muted' },
    },
    showDeals && {
      label: `Open ${labels.deal.singular.toLowerCase()} value`,
      href: `${base}/deals`,
      value: formatCompactMoney(deals.value),
      delta: deals.count ? { text: `${deals.closing_this_month || 0} closing this month`, tone: 'muted' }
                         : { text: 'None open', tone: 'muted' },
    },
    {
      label: 'Tasks due this week',
      href: `${base}/tasks`,
      value: (tasks.due_this_week || 0).toLocaleString(),
      delta: (tasks.overdue || tasks.due_today)
        ? { text: `${tasks.overdue || 0} overdue · ${tasks.due_today || 0} due today`, tone: tasks.overdue ? 'warn' : 'muted' }
        : { text: 'Nothing scheduled', tone: 'muted' },
    },
  ].filter(Boolean);

  return (
    <div className={`crm-dash__kpis${cards.length === 3 ? ' crm-dash__kpis--three' : ''}`}>
      {cards.map((c) => (
        <a key={c.label} className="text-reset text-decoration-none" href={c.href}>
          <Card padding="md" style={{ height: '100%' }}>
            <div className="text-muted small">{c.label}</div>
            <div style={{ fontSize: '1.75rem', fontWeight: 600, color: 'var(--sl-text-primary)' }}>
              {loading ? '—' : c.value}
            </div>
            <div className="small" style={{ color: DELTA_COLOR[c.delta.tone] || 'var(--sl-text-secondary)' }}>
              {c.delta.text}
            </div>
          </Card>
        </a>
      ))}
    </div>
  );
}

KpiRow.propTypes = {
  kpis: PropTypes.object,
  loading: PropTypes.bool,
  teamId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  labels: PropTypes.object,
  showDeals: PropTypes.bool,
};

export default KpiRow;
